// src/views/source-connections/components/wizard/forms/ApiKeyForm.jsx

import React from "react";
import Input from "../../../../../components/form-components/Input";

const ApiKeyForm = ({ sourceType, formData, onChange }) => {
  const handleFieldChange = (name, value) => {
    onChange({ ...formData, [name]: value });
  };

  return (
    <div>
      {sourceType.fields.map((field) => (
        <div key={field.name} className="mb-5">
          <Input
            title={
              <>
                {field.label}
                {!field.required && <span className="text-text-2 font-normal ml-1">(optional)</span>}
              </>
            }
            name={field.name}
            type={field.type === "password" ? "password" : "text"}
            enablePasswordToggle={field.type === "password"}
            value={formData[field.name] || ""}
            onChange={(e) => handleFieldChange(field.name, e.target.value)}
            placeholder={field.placeholder}
          />
          {field.helpText && (
            <p className="text-xs text-text-2 -mt-6 mb-4">{field.helpText}</p>
          )}
        </div>
      ))}

      {sourceType.dataTypes.length > 0 && (
        <div className="mb-5">
          <label className="block text-sm font-medium text-text-2 mb-2">Data to Import</label>
          <div className="flex flex-col gap-2">
            {sourceType.dataTypes.map((dt) => (
              <label
                key={dt.id}
                className="flex items-center gap-2.5 p-2.5 border border-border rounded-ctrl cursor-pointer text-sm text-text hover:bg-surface-2"
              >
                <input
                  type="checkbox"
                  checked={formData.dataTypes?.includes(dt.id) ?? dt.default}
                  onChange={(e) => {
                    const current = formData.dataTypes || sourceType.dataTypes.filter((d) => d.default).map((d) => d.id);
                    const updated = e.target.checked
                      ? [...current, dt.id]
                      : current.filter((id) => id !== dt.id);
                    onChange({ ...formData, dataTypes: updated });
                  }}
                  className="accent-primary"
                />
                {dt.label}
              </label>
            ))}
          </div>
        </div>
      )}

      <div className="flex items-start gap-2.5 p-3 bg-surface-2 border border-border rounded-ctrl text-xs text-text-2">
        <span className="text-primary mt-0.5">🔒</span>
        <span>Credentials are encrypted client-side with AES-256-GCM before transmission. Keys are never stored in plaintext.</span>
      </div>
    </div>
  );
};

export default ApiKeyForm;
